/*
 * Editorial pictures on the PDP (snippets/product-editorial.liquid).
 * - Opens the pictures in PhotoSwipe (loaded on the PDP by main-product__media-gallery), with the PDP
 *   gallery's own close/prev/next icons; arrows, swipe and the keyboard move between pictures.
 *   Without PhotoSwipe the links simply open the picture file.
 * - Products that hold several colours (UK): on variant change, show that colour's pictures first and
 *   keep the style pictures after them (a picture in both sets is shown once), at most data-max pictures.
 */
if (!customElements.get('product-editorial')) {
  customElements.define(
    'product-editorial',
    class ProductEditorial extends HTMLElement {
      connectedCallback() {
        this.links = Array.from(this.querySelectorAll('.product-editorial__item'));
        this.grid = this.querySelector('.product-editorial__grid');

        if (this.dataset.multiColour === 'true' && typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, event => {
            const sku = event?.data?.variant?.sku || '';
            const colour = sku.slice(9, 13).toLowerCase();
            if (colour && colour !== this.dataset.colour) this.showColour(colour);
          });
        }

        this.initLightbox();
      }

      disconnectedCallback() {
        this.unsubscribe?.();
        this.lightbox?.destroy();
      }

      showColour(colour) {
        this.dataset.colour = colour;
        const max = Number(this.dataset.max) || Infinity;
        const colourIds = new Set(this.links.filter(link => link.dataset.set === colour).map(link => link.dataset.mediaId));
        let shown = 0;
        // Colour cells come before the style cells in the markup, so the colour's pictures fill the first places.
        this.links.forEach(link => {
          const set = link.dataset.set;
          const wanted = set === colour || (set === 'style' && !colourIds.has(link.dataset.mediaId));
          const on = wanted && shown < max;
          link.parentElement.hidden = !on;
          if (on) shown += 1;
        });
        const visible = this.links.filter(link => !link.parentElement.hidden);
        this.hidden = visible.length === 0;
        const label = this.dataset.label || '';
        visible.forEach((link, i) => {
          link.setAttribute('aria-label', label.replace('[i]', i + 1).replace('[n]', visible.length));
        });
      }

      initLightbox() {
        if (typeof PhotoSwipeLightbox === 'undefined' || typeof PhotoSwipe === 'undefined') return;

        const icons = {
          close: document.querySelector('[data-close-icon]'),
          arrowPrev: document.querySelector('[data-prev-icon]'),
          arrowNext: document.querySelector('[data-next-icon]')
        };
        const mobile = window.matchMedia('(max-width: 749px)');

        this.lightbox = new PhotoSwipeLightbox({
          gallery: this.grid,
          children: '.product-editorial__cell:not([hidden]) .product-editorial__item',
          mainClass: 'pswp--product-media-gallery pswp--product-editorial',
          loop: true,
          showHideAnimationType: 'zoom',
          bgOpacity: 1, // white backdrop (.pswp__bg in section-product.css) that fades out on close
          initialZoomLevel: zoom => (mobile.matches ? zoom.vFill : zoom.fit),
          secondaryZoomLevel: zoom => (mobile.matches ? zoom.fit : 1),
          pswpModule: PhotoSwipe
        });
        this.lightbox.addFilter('uiElement', (element, data) => {
          const icon = icons[data.name];
          if (icon) element.innerHTML = icon.innerHTML;
          return element;
        });
        this.lightbox.on('beforeOpen', () => document.body.classList.add('overflow-hidden'));
        this.lightbox.on('closingAnimationStart', () => document.body.classList.remove('overflow-hidden'));
        this.lightbox.init();
      }
    }
  );
}
